module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/416.e46d60b9.png";